import { RecurringInvoice } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsRecurringSeries = (
  recurringInvoice: RecurringInvoice
): boolean => !!recurringInvoice.schedule?.frequency;
